// extracted by mini-css-extract-plugin
module.exports = {"badges":"uAeEjV"};